;(function(global, $){
	var queryBuilder = null;

	var QueryBuilder = function(options){
		if (null === queryBuilder){
			queryBuilder = new QueryBuilder.init(options);
		}	
		else {
			queryBuilder.doPas0();
		}
		return queryBuilder;
	};

	var _options = {
		domain: 'https://api.eu.socrata.com/api/catalog/v1',		
		filter: '.cat',
		isMapificable: true,
		limit: 200, 
		filteredDomainList: [''],
		discoveryApi:  new DiscoveryApi(),
	};
  
	QueryBuilder.prototype = {
		doPas0: function(){
			$("#pas0").show();
			$('#domainList').removeAttr('selected').find('option:first').prop('selected','selected');
			$("#pas1").hide();
			$("#results_do").hide();
			$("#pas2").hide();
			$("#pas3").hide();
		},
		getHtml: function() {
			var html;
			$.get("/static/geocatweb/templates/querybuilder0.html",function(data){
				html += data;
			});
			return html;
		},

		getPas0: function(){
			var self = this;
			$.get("/static/geocatweb/templates/querybuilder0.html",function(data){
				$("#"+self.div).append(data);

				var domainList = [];
				var selectDomains ='';
				self.discoveryApi.getList().then(
					function(results){
						var domains=[];
						$.each(results.results, function(index, item){
							if (item.metadata.domain.indexOf(".cat")!==-1) {//filtre per Catalunya
								domains.push(item.metadata.domain);								
							}
						});
						domains = [...new Set(domains)];
						domains.sort();
						$.each(domains, function(index, item){
							selectDomains += '<option value="'+item+'">'+item+'</option>' ;
						});
						
						$('#domainList').append(selectDomains);
						$('#domainList').on('change',function(){
							self.filteredDomainList = $('#domainList option:selected').val();
							if (self.filteredDomainList!=='-'){
								self.doPas1();
							}
						});
					},function(){
						domainList = ['analisi.transparenciacatalunya.cat'];
					}
				);
			});
			
		},

		getPas1: function() {
			var self = this;
			$.get("/static/geocatweb/templates/querybuilder1.html",function(data){
				$("#"+self.div).append(data);
			});	
			$("#pas1").hide();
			$("#results_do").hide();			
		},

		getPas2: function() {
			var self = this;
			$.get("/static/geocatweb/templates/querybuilder2.html",function(data){
				$("#"+self.div).append(data);				
				$("#pas2").hide();
			});
		}, 

		getPas3: function() {
			var self = this;
			$.get("/static/geocatweb/templates/querybuilder3.html",function(data){
				$("#"+self.div).append(data);
				$('.make-switch-do').bootstrapSwitch();
				$('#dinamic_chk-do').bootstrapSwitch('state', true, true);
				$("#pas3").hide();
			});
		},


		doPas1: function() {
			$("#pas0").hide();
			$('#pas1').show();
			var self = this;
			$('#input-num-resultats').attr('disabled', 'disabled');
			$('#check-catalunya').iCheck('disable');
			$('#check-mapificable').iCheck('disable');
			$("#results_do").hide();
			$("#spinner1").show();
	
			if($("#list-resources").hasClass('mCustomScrollbar')){
				$("#list-resources").mCustomScrollbar('destroy');
			}
			$("#list-resources").html('');
	
			var options = self.isMapificable ? {limit: self.limit, q:'the_geom', order:'name'} : {limit: self.limit};
	
			self.discoveryApi.filterListBy(self.filteredDomainList, options).then(function(results){
	
				$('#input-num-resultats').removeAttr('disabled', 'disabled');
				$('#check-catalunya').iCheck('enable');
				$('#check-mapificable').iCheck('enable');
	
				for(var i=0, len=results.length; i<len; ++i){
					$("#list-resources").append(
						'<button type="button" style="border: 0px;padding: 4px;text-align:left;" class="list-group-item my-list-group-item resource-item label-wms" data-url="'+results[i].domain+'" data-id="'+results[i].id+'" data-val="' + results[i].name.toUpperCase() + '" data-name="' + results[i].name + '">'+results[i].name+'</button>'
					);
				}
				//$('#num-total-resultats').html('('+results.length+' resultats)');
	
				$("#list-resources").mCustomScrollbar();
	
				$('.resource-item').off('click');
				$('.resource-item').on('click', function() {
						$("#spinner1").show();
						$("#results_do").hide();
						$("#name-resource")[0].value = $(this).data('name');
						$('#subtitol-cloudifier').html($(this).html());
						self.discoveryApi.getFinalResource($(this).data('url'), $(this).data('id'), {'$limit': 1, "$$app_token" : "17k7yewDYaSQNhrixSldiaCMG"})
						.then(function(results){
							self.drawColumns(results);
						}, function(){
							self.handleError
						});
					}
				);
	
				$('#search-input-do').off('keyup change');
				$('#search-input-do').on('keyup change', function() {
					self.filterResults();
				});
	
				$("#spinner1").hide();
				$("#results_do").show();
				$('#btn-previous-p1').off('click');
				$('#btn-previous-p1').on('click', function(){
					$("#pas0").show();
					$("#pas1").hide();
				});
			});
		}, 

		filterResults: function() {

			var needle = $('#search-input-do').val();
			if("" == needle.trim())	{
	
				$('.resource-item').show();
	
			}
			else {
			
				$('.resource-item[data-val*="' + needle.toUpperCase() + '"]').show();
				$('.resource-item:not([data-val*="' + needle.toUpperCase() + '"]').hide();
	
			}
	
		},

		drawColumns: function(response){
			var self = this;
			var obj = response.results;
			var urlResouce = response.url;
			console.debug(response);
			$("#url-resource").val(urlResouce);
			
			if($("#list-columns").hasClass('mCustomScrollbar')){
				$("#list-columns").mCustomScrollbar('destroy');
			}
			$("#list-columns").html('');
	
			$.each(obj[0], function( key, value ) {
				if("the_geom" != key)
				{
				
					$("#list-columns").append(
						'<button type="button" class="list-group-item my-list-group-item column-item btn-filtre disabled" data-key="'+key+'">'+key+'</button>'
					);
	
				}
			});
	
			$("#pas1").hide();
			$("results_do").hide();
			$("#pas2").show();
			countColumns = 0;
	
			$("#list-columns").mCustomScrollbar();
	
			$('#container-no-filtre').addClass('container-actiu');
			$('#container-no-filtre').removeClass('container-no-actiu');
			$('#container-filtre').removeClass('container-actiu');
			$('#container-filtre').addClass('container-no-actiu');
			$("#radio-no-filtre").prop( "checked", true );
			$('#radio-filtre').on('click', function(){
				$('#container-filtre').removeClass('container-no-actiu');
				$('#container-filtre').addClass('container-actiu');
				$('#container-no-filtre').removeClass('container-actiu');
				$('#container-no-filtre').addClass('container-no-actiu');
	
				$('.list-group-item').removeClass('disabled');
				$('#btn-next-p2').addClass('not-active');
	
			});
	
			$('#radio-no-filtre').on('click',function(){				
				$('#container-no-filtre').removeClass('container-no-actiu');
				$('#container-no-filtre').addClass('container-actiu');
				$('#container-filtre').removeClass('container-actiu');
				$('#container-filtre').addClass('container-no-actiu');
	
				$('.list-group-item').removeClass('active');
				$('.list-group-item').addClass('disabled');
	
				$('#btn-next-p2').removeClass('not-active');
				countColumns = 0;
	
			});
			
			$('.column-item').off('click');
			$('.column-item').on('click', function(){
				if(!$(this).hasClass('disabled')){
					if ($(this).hasClass('active')){
						$(this).removeClass('active');
						countColumns--;
					}else{
						$(this).addClass('active');
						countColumns++;
					}
					checkNextp2();
				}
			});
	
			function checkNextp2(){
				if(countColumns== 0){
					$('#btn-next-p2').addClass('not-active');
				} else{
					$('#btn-next-p2').removeClass('not-active');
				}
			}
	
			$('#btn-next-p2').off('click');
			$('#btn-next-p2').on('click', function(){
				if($('#container-filtre').hasClass('container-actiu')){
					self.goToPas3();
				}else{
					self.goToPas4();
				}
			});
	
			$('#btn-previous-p2').off('click');
			$('#btn-previous-p2').on('click', function(){
				$('#subtitol-cloudifier').html('Prototip de cerca dels portals de dades obertes (SOCRATA)');
				$("#pas1").show();
				$("#pas2").hide();
			});
		},

		goToPas3: function() {
			var self = this;
			$("#pas2").hide();
			$("#info3").hide();
			$("#spinner3").show();
			$("#pas3").show();
			self.addTableData().then(function(){
				self.loadChecks('my-check');
				$('.my-check').off('ifToggled');
				$('.my-check').on('ifToggled',function(){
					self.updateQuery();
				});
				self.updateQuery();
				$('select.querybuilder-select').on('change', function() {self.updateQuery();});
				$("#spinner3").hide();
				$("#info3").show();
			});
		},

		goToPas4: function() {
			var self = this;
			self.updateQuery();
			var queryUrl = $("#url-resource").val().replace(".json",".geojson") ;
			self.discoveryApi.getGeometryType(queryUrl).then(function(res){
				var tipusGeom =""; 
				if (res.results[0]!==undefined){
					if (res.results[0].the_geom!==undefined) {
						tipusGeom = res.results[0].the_geom.type;
					}
				}
				else if (res.results.features[0]!==undefined){
					tipusGeom = res.results.features[0].geometry.type
				}
				
				if (tipusGeom=="Point"){
					if (queryUrl.indexOf("query")==-1){
						//?$query=SELECT%20*%20%20WHERE%20(propietari%3D'CTTI'%20)%20%20LIMIT%2060000"
						queryUrl=queryUrl+"?$query=SELECT *";
					}
					queryUrl = queryUrl + " LIMIT 60000";
					self.loadInMap(queryUrl,"30000","60000");
				}
				else {
					if (queryUrl.indexOf("query")==-1){
						//?$query=SELECT%20*%20%20WHERE%20(propietari%3D'CTTI'%20)%20%20LIMIT%2060000"
						queryUrl=queryUrl+"?$query=SELECT *";
					}
					queryUrl = queryUrl + " LIMIT 20000";
					self.loadInMap(queryUrl,"10000","20000");
				}
			});
			
			
		},

		addTableData: function(){
			var self = this;
			var defer = $.Deferred();
	
			$('#table-body').html('');
			$('#select-camp-ordre').html('<option value="" >defecte</option>');
	
			var urlResource = $("#url-resource").val();
	
			var selectOperador =
				'<option value="=">=</option>' +
				'<option value="<"><</option>' +
				'<option value=">">></option>' +
				'<option value="!=">!=</option>';
	
			var inputValor = '<input lang="ca" type="text" class="form-control textarea_querybuilder_2" placeholder="valor">';
	
			var count = $('.column-item.active').length;
	
			var tipusGeom="";
			self.discoveryApi.getGeometryType(urlResource).then(function(res){
				tipusGeom = res.results[0].the_geom.type;
				if (tipusGeom=="Point"){
					$('#input-num-reg-est')[0].value="30000";
					$('#input-num-reg-din')[0].value="60000";
				}
				else {
					$('#input-num-reg-est')[0].value="10000";
					$('#input-num-reg-din')[0].value="20000";
				}
			});

			$('.column-item.active').each(function() {
				
				self.discoveryApi.getColValues(urlResource,$(this).data('key')).then(function(res){
					var selectColValues = "";
					$.each(res.results, function(index, item){
						selectColValues += '<option value="'+item[res.nameCol]+'">'+item[res.nameCol]+'</option>';
					});
					var numCol = 1;
					if ( $("numCol_"+res.nameCol) !==undefined) {
						numCol = $("numCol_"+res.nameCol).val();
					}
					$('#table-body').append(
						'<tr>'+
							'<td><span class="table-atribut">' + res.nameCol + '</span></td>'+
							'<td><select class="querybuilder-select" id="' + res.nameCol + '">'+selectOperador +'</td>'+
							'<td><select class="querybuilder-select" style="width:200px;">'+selectColValues +'</td>'+
							'<td><a href="#" onclick="queryBuilder.addFilter(\''+res.nameCol+'\');">'+
							'<i class="fa fa-plus-circle" style="font-size: 17px;"></i></a>'+
							'<input type="hidden" id="numCol_'+res.nameCol+'" value="'+numCol+'"/></td>'+
							// '<td>' + inputValor + '</td>'+
						'</tr>'
					);
	
					count--;
					if(count==0){
						defer.resolve();
					}
				});
	
				$('#select-camp-ordre').append(
					'<option  >'+ $(this).data('key') +'</option>'
				);
	
			});
	
			

			$('select.querybuilder-select').on('change', function() {self.updateQuery();});
			$('#table-body').off('keyup');
			$('#table-body').on('keyup', '.form-control', function(){self.updateQuery()});
			$('#table-body').off('change');
			$('#table-body').on('change', '.visible', function(){self.updateQuery()});
	

			$('input[name="dinamic-checkbox-do"]').on('switchChange.bootstrapSwitch', function(event, state) {
				if(state.value == true) {
					$('#limit-din-div').attr("style","display:none;");
					$('#limit-est-div').attr("style","display:relative;");
				}
				else {
					$('#limit-din-div').attr("style","display:relative;");
					$('#limit-est-div').attr("style","display:none;");
				}
			});

			$('#check-num-reg').off('click');
			$('#check-num-reg').on('click',function(){
				if ($('#check-num-reg')[0].checked) {
					$('#input-num-reg-est').removeAttr('disabled');
					$('#input-num-reg-din').removeAttr('disabled');
				}
				else {
					$('#input-num-reg-est')[0].value="";
					$('#input-num-reg-est').attr('disabled','disabled');
					$('#input-num-reg-din')[0].value="";
					$('#input-num-reg-din').attr('disabled','disabled');
				}
			});
			$('#input-num-reg').on('keyup',function(){self.updateQuery()});
			$('#select-camp-ordre').off('change');
			$('#select-camp-ordre').on('change', function(){self.updateQuery()});
			$('#select-sentit-ordre').off('change');
			$('#select-sentit-ordre').on('change', function(){self.updateQuery()});
	
			$('#btn-previous-p3').off('click');
			$('#btn-previous-p3').on('click', function(){
				$('#pas2').show();
				$('#pas3').hide();
			});
			
			$('#btn-next-query').off('click');
			$('#btn-next-query').on('click', function(){
				self.updateQuery(tipusGeom);	
				var query = $('#queryText').val();
				var queryUrl = $("#url-resource").val().replace(".json",".geojson") + "?$query=" + query;
				var limitest = $('#input-num-reg-est').val();
				if (tipusGeom=="Point"){
					var intNumReg=parseInt(limitest);
					if (intNumReg>30000) limitest = "30000";				
					var limitdin = $('#input-num-reg-din').val();
					var intNumReg2=parseInt(limitdin);
					if (intNumReg2>60000) limitdin = "60000";
					self.loadInMap(queryUrl,limitest,limitdin,$('#dinamic_chck-do').bootstrapSwitch('state'));	
				}
				else {
					var intNumReg=parseInt(limitest);
					if (intNumReg>10000) limitest = "10000";				
					var limitdin = $('#input-num-reg-din').val();
					var intNumReg2=parseInt(limitdin);
					if (intNumReg2>20000) limitdin = "20000";	
					self.loadInMap(queryUrl,limitest,limitdin,$('#dinamic_chck-do').bootstrapSwitch('state'));
				}
							
			});
	
			return defer.promise();
		
		},

		addFilter: function(nameCol){
			var self=this;
			var urlResource = $("#url-resource").val();
			var numCol = 1;
			if ($("numCol_"+nameCol)!==undefined){
				numCol = $("numCol_"+nameCol).val();
				$("numCol_"+nameCol).value = numCol+1;
			}				
			
			var selectOperador =
				'<option value="=">=</option>' +
				'<option value="<"><</option>' +
				'<option value=">">></option>' +
				'<option value="!=">!=</option>';
			self.discoveryApi.getColValues(urlResource,nameCol).then(function(res){
				var selectColValues = "";
				$.each(res.results, function(index, item){
					selectColValues += '<option value="'+item[res.nameCol]+'">'+item[res.nameCol]+'</option>';
				});
				
				$('#table-body').append(
					'<tr>'+
						'<td><span class="table-atribut">' + res.nameCol + '</span></td>'+
						'<td><select class="querybuilder-select" id="' + res.nameCol + '_'+numCol+'">'+selectOperador +'</td>'+
						'<td><select class="querybuilder-select" style="width:200px;">'+selectColValues +'</td>'+
						'<td><a href="#" onclick="queryBuilder.addFilter(\''+res.nameCol+'\');">'+
						'<i class="fa fa-plus-circle" style="font-size: 17px;"></i></a>'+
						'<input type="hidden" id="numCol_'+nameCol+'" value="'+numCol+'"/></td>'+
						// '<td>' + inputValor + '</td>'+
					'</tr>'
				);				
			});	
			$('select.querybuilder-select').on('change', function() {self.updateQuery();});	
			
		},

		updateQuery: function(tipusgeom){
			var self = this;
			
				$('#btn-next-query').removeClass('disabled');
				var query = "SELECT * ";
				/*$.each(visibles, function(  ) {
					query+= " "+$(this).data('key')+",";
				});
				query = query.slice(0,-1);*/
				var wheres = [];
				var wheresValors = {};
				$('#table-body').find('tr').each(function(){
					var id = $(this).find('td').eq(0).text();
					var operator = $(this).find('td').eq(1).find('select').val();
					var value = $(this).find('td').eq(2).find('select').val();
					wheres.push(id + operator +  "'" + value +  "'");					
					if (wheresValors[id]!==undefined) {
						var wheresArr = wheresValors[id];
						wheresArr.push(id + operator + "'" + value +  "'");
						wheresValors[id] = wheresArr;
					}
					else {
						var wheresArr = [];
						wheresArr.push(id + operator +  "'" + value +  "'");
						wheresValors[id] = wheresArr;
						
					}
				});
				console.log(wheresValors);
				if(wheres.length != 0){
					query +=" WHERE ";
					//query += wheres.join(' AND ');
				}

				var conector = "AND";
				conector = document.querySelector('input[name="separadorC"]:checked').value;

				var valorsDiferents = Object.keys(wheresValors);
				
				valorsDiferents.forEach(function(value) {
					var arrayV = wheresValors[value];
					query += "(";
					if (arrayV!==undefined) {
						arrayV.forEach(function(value){
							query += value + ' OR ';
						});
						query = query.substring(0,query.length-3);
					}	
					query += ") "+conector+" ";
				});
				query = query.substring(0,query.length-4);
				console.log(query);
	
				var numRegistres = $('#input-num-reg-din').val();
				if (tipusgeom!==undefined && tipusgeom!==""){
					if (tipusgeom=="Point"){
						var intNumReg=parseInt(numRegistres);
						if (intNumReg>60000) numRegistres = "60000";
						query +=" LIMIT "+numRegistres;
					}
					else {
						var intNumReg=parseInt(numRegistres);
						if (intNumReg>20000) numRegistres = "20000";
						query +=" LIMIT "+numRegistres;
					}
				}
				
				/*if(!self.isBlank(numRegistres)){
					query +=" LIMIT "+numRegistres;
				}
				else {
					query +=" LIMIT 50000";					
				}*/
	
				var campOrdre = $('#select-camp-ordre').val();
				if(!self.isBlank(campOrdre)){
					query +=" ORDER BY "+campOrdre + " "+ $('#select-sentit-ordre').val();
				}
				query=encodeURIComponent(query);
				$('#queryText').val(query);
			
		},

		loadInMap: function(queryUrl,limitest,limitdin,isestatic){
			$('#pas3').hide();
			$('#li_do').hide();
			$('#li_geoserveis').hide();
			$('#li_dadesusuaris').hide();
			$('#li_dadesnuvol').show();
			jQuery("#id_url_file").html(
				'<div id="container_altres_fonts_dades">'
			);	
			$('a[href^="#id_url_file').click();		
				
			var _instamapsDadesExternes = new InstamapsDadesExternes(
				{container:$('#container_altres_fonts_dades')}
			);
			if (queryUrl.indexOf("query")==-1){
				//?$query=SELECT%20*%20%20WHERE%20(propietari%3D'CTTI'%20)%20%20LIMIT%2060000"
				queryUrl=queryUrl+"=SELECT *";
			}
			if (isestatic){
				queryUrl = queryUrl.substring(0,queryUrl.indexOf("LIMIT"));
				queryUrl = queryUrl+ " LIMIT "+limitest;
			}
			else {
				queryUrl = queryUrl.substring(0,queryUrl.indexOf("LIMIT"));
				queryUrl = queryUrl+ " LIMIT "+limitdin;
			}

			setTimeout(function(){ 
				$('#limit-din').val(limitest);
				$('#limit-est').val(limitdin);
				$('#es-estatic').val(isestatic);
				$('#txt_URLfile').val(queryUrl);
				$('#bt_URLfitxer').data('isDO','true');
				$('#bt_URLfitxer').click();
			},500);

		
		},

		loadChecks: function(className){
			$('.'+className+'').iCheck({
				checkboxClass: 'icheckbox_polaris',
				radioClass: 'iradio_polaris',
				increaseArea: '-10%' // optional
			});
		},
		
		isBlank: function(str) {
			return (!str || (/^\s*$/).test(str));
		},

		handleError: function(error){
			console.error(error);
		},
	
	};

	QueryBuilder.init = function(options){
		var self = this;
		self = $.extend(self, _options, options);
		this.getPas0();
		this.getPas1();
		this.getPas2();
		this.getPas3();
	}
  
	QueryBuilder.init.prototype = QueryBuilder.prototype;
  
	global.QueryBuilder = QueryBuilder;
  
  }(window, jQuery));